<template>
  <div class="activity-single" @click="todetail(item.id)">
    <div class="activity-image">
      <div class="activity-bg" :style="{background:'url('+item.coverimg+') top center/100% no-repeat'}"></div>
      <div class="activity-mask"></div>
      <div class="draft-end flex-vc" style="display: none">
        <div class="white-font font-siny font-size12 flex-cm smooth end-font">{{openid==item.openid ? '管理员' : '协作员'}}</div>
      </div>
      <div class="white-font font-size12 flex-lr activity-count">
        <div>{{item.submissionCount}} 投稿</div>
        <div class="flex-lm">
            <!--
            <div class="draft-new-label font-size12 flex-cm">{{item.long_term==1 || item.interval>0 ? 'NEW' : 'END'}}</div>
            <div v-if="item.type==3">{{item.imgCount}}个作品</div>
            <div v-else-if="item.type==2">{{item.imgCount}}个视频</div>
            <div v-else>{{item.imgCount}}张照片</div>
            -->
        </div>
      </div>
      <div class="activity-clean-view">
        <lastday :detail="item"></lastday>
      </div>
    </div>
    <div class="activity-info flex-vl">
      <div class="black-font font-size16 font-more activity-name font-more">{{item.name}}</div>
      <div :class="[currenttime<item.etime || item.long_term==1 ? 'flex-lr' : 'flex-rr']" style="padding-top:8px;width:100%;">
        <div class="flex-lm font-size14 gray-font" v-if="item.long_term && item.long_term==1">
         <span>{{item.status==1 ? '进行中' : ''}}</span>
         <span class="font-size16" style="padding:0 5px 8px 5px;">.</span>长期征集
        </div>
        <div class="flex-lm font-size14 gray-font" v-else-if="item.interval && item.interval>0">
         <span v-if="currenttime<item.stime">{{item.status==1 ? '未开始' : '已暂停'}}</span>
         <span v-else-if="currenttime>=item.stime && currenttime<item.etime">{{item.status==1 ? '征集中' : '已暂停'}}</span>
         <span class="font-size16" style="padding:0 5px 8px 5px;">.</span>距截稿{{item.interval}}天
        </div>
        <div class="flex-lm font-size14 gray-font" v-else-if="item.interval && item.interval<=0">
         <span v-if="currenttime>=item.stime && currenttime<item.etime">{{item.status==1 ? '进行中' : '已暂停'}}</span>
         <span class="font-size16" style="padding:0 5px 8px 5px;" v-if="currenttime>=item.stime && currenttime<item.etime">.</span>
         <span v-if="currenttime>=item.stime && currenttime<item.etime">已截稿</span>
        </div>
        <div class="flex-lm font-size14 gray-font" v-else-if="!item.interval">
          <span v-if="currenttime<item.stime">{{item.status==1 ? '未开始' : '已暂停'}}</span>
          <span v-else-if="currenttime>=item.stime && currenttime<item.etime">{{item.status==1 ? '进行中' : '已暂停'}}</span>
        </div>
        <div :class="['white-font invite-button flex-cm font-size14',action=='topath' ? 'bg-green' : '']" @click.stop="invite(item.id)" v-if="(item.long_term && item.long_term==1) || currenttime<item.etime">{{action=='topath' ? '邀请投稿' : ''}}</div>
        <div class="white-font invite-button flex-cm font-size14 bg-deepen-gray" v-else>已结束</div>
      </div>
    </div>
  </div>
</template>

<script>
    import App from '../util/comfun'
    import lastday from './dialog/draft-lastday.vue'
export default {
    name: 'collect',
    components:{
      lastday,
    },
    props:{
      item:Object,
      action:{
        type:String,
        value:'topath'
      },
    },
    data () {
      return {
        openid:JSON.parse(localStorage.getItem('userinfo')).openid,
        currenttime:Date.parse(new Date())/1000,
        buyStorageUrl:'',
      }
    },
    methods:{
      unixtoTime:App.unixtoTime,
      todetail(id){
        console.log(id,this.action)
        if(this.action=='topath'){
          console.log('ddddd')
            this.$router.push({
               path:'/home/activity/detail/'+id,
            })
        }
        sessionStorage.setItem('selectdraftId',id)
        sessionStorage.setItem('selectdraftName',this.item.name)
        this.$emit('selectdraft',{id:id,action:'click',name:this.item.name});
      },
      invite(id){
        console.log(id);
        this.$emit('invite',this.item);
      },
      getH5params(key=''){
        let params={};
        params[key]=encodeURIComponent(JSON.stringify({
          userId:wxlite.getStorageSync('userId'),
          //hasInBusiness:wxlite.hasInBusiness?1:0,

          from:'pc',
          token:wxlite.getStorageSync('token'),
          uid:this.item.createBy}));
        return App.getH5({
          ...params,
          '_':'',
        },'');
      },
      buyStorage(){
        this.buyStorageUrl=this.getH5params('buy-storage')
      },
    },
      mounted(){
        this.buyStorage()
      }
  }
</script>

<style>
  .activity-single {
      width: 350px;
      height: 283px;
      -webkit-box-shadow: 0 0 4px 2px rgba(224,223,223,.5);
      box-shadow: 0 0 4px 2px rgba(224,223,223,.5);
      border-radius: 5px;
      margin: 0 10px 35px 25px;
      cursor: pointer;
      top: 0;
      -webkit-transition: top .3s ease,-webkit-box-shadow .3s ease;
      transition: top .3s ease,-webkit-box-shadow .3s ease;
      transition: box-shadow .3s ease,top .3s ease;
      transition: box-shadow .3s ease,top .3s ease,-webkit-box-shadow .3s ease;
  }
  .activity-single:hover{
    top:4px;
    box-shadow:-4px 4px 16px 2px rgba(224,223,223,1) ;
  }
  .activity-image {
      width: 100%;
      height: 200px;
      background: #eee;
  }
  .activity-bg {
      width: 100%;
      height: 100%;
  }
  .draft-end {
      width: 75px;
      height: 25px;
      position: absolute;
      top: 5px;
      left: -22.5px;
      background: -webkit-gradient(linear,left top,left bottom,color-stop(10%,#fb7741),to(#f5515f));
      background: linear-gradient(180deg,#fb7741 10%,#f5515f);
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
      -webkit-transform-origin: 50% 50%;
      transform-origin: 50% 50%;
  }
  .activity-count {
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 8px;
      padding: 0 5px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
  }
  .draft-new-label {
      padding: 2px 5px 1px;
      background: -webkit-gradient(linear,right top,left top,from(#f5515f),to(#fb7741));
      background: linear-gradient(270deg,#f5515f,#fb7741);
      border-radius: 2px;
      margin-right: 5px;
  }
  .activity-info {
      width: 100%;
      padding: 15px 5px 10px;
  }
  .activity-info, .draft-end {
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
  }
  .activity-info {
      width: 100%;
      padding: 15px 5px 10px;
  }
  .activity-name {
      width: 100%;
      line-height: 25px;
  }
  .invite-button {
      width: 80px;
      height: 28px;
      border-radius: 15px;
      font-weight: 500;
  }
  .activity-image, .activity-single {
      overflow: hidden;
      position: relative;
  }
  .activity-clean-view{
      position: absolute;
      right: 0;
      top: 10px;
  }
  
</style>



// WEBPACK FOOTER //
// src/components/collect.vue